<div
  class="chat-bubble"
  [ngClass]="{
    'chat-bubble-left':
      type === 'from_assistant' ||
      type === 'from_system' ||
      type === 'from_assistant_job_posting',
    'chat-bubble-right': type === 'from_user'
  }"
  (click)="
    type === 'from_assistant_tailored_cover_letter' && coverLetter
      ? openCoverLetterInNewTab()
      : null
  "
>
  <div class="chat-bubble-header">
    <span class="header-text">{{ getHeaderText(type) }}</span>
    <span class="header-icons" [ngClass]="{ 'show-tooltip': isCopied }">
      <span class="tooltip" *ngIf="isCopied">{{ t.TOOLTIP_COPIED }}</span>
      <i
        [ngClass]="isCopied ? 'bi bi-check-circle-fill' : 'bi bi-clipboard'"
        (click)="copyToClipboard()"
        [attr.title]="t.TOOLTIP_COPY_TO_CLIPBOARD"
      ></i>
    </span>
  </div>

  <div class="chat-bubble-content">
    <ng-container
      *ngIf="type === 'from_assistant_job_posting'; else defaultContent"
    >
      <app-job-posting [job]="parsedJobPosting"></app-job-posting>
    </ng-container>
    <ng-template #defaultContent>
      <ng-container
        *ngIf="
          type !== 'from_assistant_tailored_cover_letter';
          else coverLetterTemplate
        "
      >
        <p class="mb-0">{{ content }}</p>
      </ng-container>
      <ng-template #coverLetterTemplate>
        <app-cover-letter [coverLetter]="coverLetter"></app-cover-letter>
      </ng-template>
    </ng-template>
  </div>

  <div class="chat-bubble-footer">
    <p class="mb-1 small chat-timestamp">{{ date }}</p>
  </div>
</div>
